module.exports = __webpack_public_path__ + "img/style_4_en.8f24d968.jpeg";